
	import { defineComponent } from "vue";
	import NavBar from "@/components/NavBar.vue";
	import VideoCallFrame from "@/components/VideoCallFrame.vue";
import { RouteLocationNormalizedLoaded, useRoute } from "vue-router";

	export default defineComponent({
		components: {
			VideoCallFrame,
			NavBar,
		},
		setup() {
			const route : RouteLocationNormalizedLoaded = useRoute()

			return {
				callId: route.query.id
			}
		},
	});
